import { module } from 'angular';
import noteContextComponent from '~/components/comments/note-context/note-context.component';
import noteCommentComponent from '~/components/comments/note-comment/note-comment.component';
import commentsComponent from './comments.component';

export default module('app')
	.component('noteComment', noteCommentComponent)
	.component('noteContext', noteContextComponent)
	.component('comments', commentsComponent)
	.name;
